import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteImages } from '../../../_global/fragments/generated/CompleteImages';
import { UserPreferences } from '../../types/generated/UserPreferences.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type MeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'AuthenticatedUser', intercomHash?: string | null, timezone?: any | null, avatarColor?: Types.AvatarColor | null, googleAuthEnabled?: boolean | null, requiresEmailConfirmation: boolean, uiTheme?: Types.UiTheme | null, firstLoginAt?: string | null, adobeAuthId?: string | null, isEdu?: boolean | null, personalAccountCreationBlocked?: boolean | null, id: string, email: string, name?: string | null, inboxAccounts?: { __typename?: 'InboxAccountConnection', nodes: Array<{ __typename?: 'InboxAccount', id?: string | null, userType?: Types.AccountUserTypeEnum | null }> } | null, profileImage?: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null } | null, profile?: { __typename?: 'UserProfile', jobTitle?: string | null, organizationName?: string | null } | null, clientPreferences?: { __typename?: 'UserClientPreferences', hasProvidedTranscriptionDiarizationConsent: boolean, allowShareTracking: boolean, aiAssistantPromptHidden: boolean, locales?: { __typename?: 'LocalePreferences', email?: Types.SupportedLocale | null, web?: Types.SupportedLocale | null } | null } | null } | { __typename?: 'IdentifiedUser', avatarColor?: Types.AvatarColor | null, id: string, email: string, name?: string | null, intercomHash?: string | null } | null };


export const Me = /*#__PURE__*/ gql`
    query Me {
  me {
    id
    email
    name
    intercomHash
    ... on IdentifiedUser {
      avatarColor
    }
    ... on AuthenticatedUser {
      inboxAccounts(page: {first: 1}) {
        nodes {
          id
          userType
        }
      }
      intercomHash
      timezone
      profileImage {
        ...CompleteImages
      }
      profile {
        jobTitle
        organizationName
      }
      avatarColor
      googleAuthEnabled
      requiresEmailConfirmation
      uiTheme
      firstLoginAt
      adobeAuthId
      isEdu
      personalAccountCreationBlocked
      ...UserPreferences
    }
  }
}
    ${CompleteImages}
${UserPreferences}` as unknown as DocumentNode<MeQuery, MeQueryVariables>;

          

          export const useMeQuery = (options?:QueryHookOptions<MeQuery, MeQueryVariables>) => useQuery(Me, options);

          

          export type MeQueryOptions = QueryHookOptions<MeQuery, MeQueryVariables>;

          

          export const useMeLazyQuery = (options?:LazyQueryHookOptions<MeQuery, MeQueryVariables>) => useLazyQuery(Me, options);

          

          export type MeQueryResult = ReturnType<typeof useMeQuery>;

          
